import React from 'react'
import Rooms from './Rooms'
import Testimonials from './Testimonials'
import FinePrint from './FinePrint'
import Map from './Map'
import lodgeStyles from './lodge.module.sass'

// import socialStyles from './social.module.sass';
const pigsGoogleMapLink = 'https://goo.gl/maps/3AZKSGjmaCy'

export default props => {
  const { acf, acfOptions } = props

  // console.log(acf)

  return (
    <div className={lodgeStyles.lodge}>
      <Testimonials acf={acf} addClasses={lodgeStyles.testimonials} />
      <Rooms acf={acf} addClasses={lodgeStyles.rooms} />
      <FinePrint
        acf={acf}
        addClasses={lodgeStyles.fineprint}
        faq={acfOptions.faq_lodge}
        section="Lodge"
        show_button
      />
      <Map
        id="map"
        addClasses={lodgeStyles.map}
        options={{
          center: { lat: 51.394226, lng: -116.48992 },
          zoom: 15,
          mapTypeId: 'terrain',
          mapTypeControl: false,
        }}
        onMapLoad={map => {
          const loc = {
            position: new window.google.maps.LatLng(51.394226, -116.48992),
            type: 'info',
          }

          const markerTab = {
            path:
              'M47.76,24.56c0,12.77-23.13,41.63-23.13,41.63S1.49,37.33,1.49,24.56a23.13,23.13,0,0,1,46.26,0',
            scale: 0.5,
            fillOpacity: 1,
            fillColor: '#E4B114',
            strokeColor: 'white',
            strokeWeight: 2,
            anchor: new window.google.maps.Point(22, 50),
          }

          // const markerTabGreen = {
          //   path: "M47.76,24.56c0,12.77-23.13,41.63-23.13,41.63S1.49,37.33,1.49,24.56a23.13,23.13,0,0,1,46.26,0",
          //   scale: 0.5,
          //   fillOpacity: 1,
          //   fillColor: 'green',
          //   strokeColor: 'white',
          //   strokeWeight: 2,
          //   anchor: new window.google.maps.Point(22, 50),
          // }

          const marker = new window.google.maps.Marker({
            position: loc.position,
            icon: markerTab,
            map: map,
            title: 'Click to view in Google Maps',
          })

          const info = new window.google.maps.InfoWindow({
            // content: 'InfoWindow content'
            content:
              '<div class="infowindow"><h2 class="infowindow__headline">Truffle Pigs Bistro &amp; Lodge</h2><p class="infowindow__desc">View on Google Maps</p><a class="infowindow__link" href="' +
              pigsGoogleMapLink +
              '">See Map</a></div>',
          })

          window.google.maps.event.addListener(marker, 'click', () => {
            // marker.setIcon(markerTabGreen);
            window.location.href = pigsGoogleMapLink
          })

          // marker.addListener('click', function() {
          //   info.open(map, marker);
          // });

          window.google.maps.event.addListener(marker, 'mouseover', () => {
            info.open(map, marker)
          })

          // window.google.maps.event.addListener(marker, 'mouseout', () => {
          //   info.close();
          // });
        }}
      />
    </div>
  )
}
